import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Nav, Tab, Alert } from 'react-bootstrap';
import GTable from 'components/tables/GTable';
import { activityLogColumns } from '../columns/taskActivityLogsColumns';
import { ActivityLog, TaskTabsProps } from '../types/activityLog';
import { GET_ACTIVITY_LOGS } from 'services/api/task';
import LoadingPlaceholder from 'components/loading-placeholder/LoadingPlaceholder';

const TaskTabs: React.FC<TaskTabsProps> = ({
  taskData,
  taskColumns,
  isLoadingTasks,
  tasksError,
  onTabChange
}) => {
  const [activeTab, setActiveTab] = useState<string>('tasks');

  const {
    data: activityLogs = [],
    isLoading: isLoadingLogs,
    error: logsError,
    refetch: refetchActivityLogs
  } = useQuery({
    queryKey: ['activityLogs'],
    queryFn: GET_ACTIVITY_LOGS,
    staleTime: 0,
    select: (response: any) => response.data,
    enabled: activeTab === 'activityLogs',
    refetchOnMount: true,
    refetchOnWindowFocus: false
  });

  const handleTabSelect = (key: string | null) => {
    if (key) {
      setActiveTab(key);

      if (key === 'activityLogs') {
        refetchActivityLogs();
      } else if (key === 'tasks' && onTabChange) {
        onTabChange('tasks');
      }
    }
  };

  return (
    <Tab.Container
      id="task-tabs"
      activeKey={activeTab}
      onSelect={handleTabSelect}
    >
      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link eventKey="tasks">Tasks</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="activityLogs">Activity Logs</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="tasks">
          {isLoadingTasks ? (
            <LoadingPlaceholder />
          ) : tasksError ? (
            <Alert variant="danger">{tasksError as string}</Alert>
          ) : (
            <GTable
              data={taskData || []}
              columns={taskColumns}
              isLoading={isLoadingTasks}
            />
          )}
        </Tab.Pane>
        <Tab.Pane eventKey="activityLogs">
          {isLoadingLogs ? (
            <LoadingPlaceholder />
          ) : logsError ? (
            <Alert variant="danger">{logsError as string}</Alert>
          ) : (
            <GTable
              data={activityLogs as ActivityLog[]}
              columns={activityLogColumns()}
              isLoading={isLoadingLogs}
            />
          )}
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default TaskTabs;
